import { useId } from 'react';
import { LiksRagRetrievalSettings } from '../../../components/liks/LiksRagRetrievalSettings/LiksRagRetrievalSettings';
import { useI18n } from '../../../i18n/useI18n';
import { ChatbotSettingsCardFooter } from './ChatbotSettingsCardFooter';

type ChatbotAiConfigurationCardProps = {
  systemPrompt: string;
  maxResults: number;
  minScore: number;
  isDirty: boolean;
  isSaving: boolean;
  discardLabel: string;
  saveLabel: string;
  onSystemPromptChange: (value: string) => void;
  onMaxResultsChange: (value: number) => void;
  onMinScoreChange: (value: number) => void;
  onDiscard: () => void;
  onSave: () => void;
};

export function ChatbotAiConfigurationCard({
  systemPrompt,
  maxResults,
  minScore,
  isDirty,
  isSaving,
  discardLabel,
  saveLabel,
  onSystemPromptChange,
  onMaxResultsChange,
  onMinScoreChange,
  onDiscard,
  onSave,
}: ChatbotAiConfigurationCardProps) {
  const { translate } = useI18n();
  const systemPromptId = useId();
  const presetsName = useId();

  return (
    <div className="chatbot-settings__card">
      <div className="chatbot-settings__body">
        <h2 className="chatbot-settings__title">
          {translate('chatbots.settings.aiConfiguration.title')}
        </h2>

        <div className="chatbot-settings__field">
          <label className="chatbot-settings__label" htmlFor={systemPromptId}>
            {translate('chatbots.settings.aiConfiguration.systemPromptLabel')}
          </label>
          <textarea
            id={systemPromptId}
            className="chatbot-settings__textarea"
            value={systemPrompt}
            onChange={(event) => onSystemPromptChange(event.target.value)}
            placeholder={translate(
              'chatbots.settings.aiConfiguration.promptPlaceholder',
            )}
            rows={6}
            disabled={isSaving}
          />
        </div>

        <LiksRagRetrievalSettings
          maxResults={maxResults}
          minScore={minScore}
          onMaxResultsChange={onMaxResultsChange}
          onMinScoreChange={onMinScoreChange}
          disabled={isSaving}
          presetsName={presetsName}
          presetsLegend={translate('common.ragRetrieval.presetsLabel')}
          presetLabels={{
            focused: translate('common.ragRetrieval.focused'),
            balanced: translate('common.ragRetrieval.balanced'),
            broad: translate('common.ragRetrieval.broad'),
          }}
          maxResultsLabel={translate(
            'chatbots.settings.aiConfiguration.maxResultsLabel',
          )}
          maxResultsDescription={translate(
            'chatbots.settings.aiConfiguration.maxResultsDescription',
          )}
          minScoreLabel={translate(
            'chatbots.settings.aiConfiguration.minScoreLabel',
          )}
          minScoreDescription={translate(
            'chatbots.settings.aiConfiguration.minScoreDescription',
          )}
        />
      </div>

      <ChatbotSettingsCardFooter
        isDirty={isDirty}
        isSaving={isSaving}
        isSaveDisabled={!isDirty || isSaving}
        discardLabel={discardLabel}
        saveLabel={saveLabel}
        onDiscard={onDiscard}
        onSave={onSave}
      />
    </div>
  );
}
